/* tslint:disable */
/* eslint-disable */
/**
 * Gestionale.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DocumentoMacelloCreateDTO
 */
export interface DocumentoMacelloCreateDTO {
    /**
     * 
     * @type {number}
     * @memberof DocumentoMacelloCreateDTO
     */
    idAnagrafeMittente?: number;
    /**
     * 
     * @type {number}
     * @memberof DocumentoMacelloCreateDTO
     */
    idAnagrafeDestinatario?: number;
    /**
     * 
     * @type {Date}
     * @memberof DocumentoMacelloCreateDTO
     */
    dataDocumento?: Date;
    /**
     * 
     * @type {string}
     * @memberof DocumentoMacelloCreateDTO
     */
    numeroDocumento?: string | null;
    /**
     * 
     * @type {Date}
     * @memberof DocumentoMacelloCreateDTO
     */
    dataOperazione?: Date;
    /**
     * 
     * @type {string}
     * @memberof DocumentoMacelloCreateDTO
     */
    note?: string | null;
    /**
     * 
     * @type {string}
     * @memberof DocumentoMacelloCreateDTO
     */
    tipo?: string | null;
    /**
     * 
     * @type {number}
     * @memberof DocumentoMacelloCreateDTO
     */
    idAnagrafePrimario?: number | null;
    /**
     * 
     * @type {number}
     * @memberof DocumentoMacelloCreateDTO
     */
    idAnagrafeSecondario?: number | null;
    /**
     * 
     * @type {boolean}
     * @memberof DocumentoMacelloCreateDTO
     */
    fineCarico?: boolean;
}

/**
 * Check if a given object implements the DocumentoMacelloCreateDTO interface.
 */
export function instanceOfDocumentoMacelloCreateDTO(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DocumentoMacelloCreateDTOFromJSON(json: any): DocumentoMacelloCreateDTO {
    return DocumentoMacelloCreateDTOFromJSONTyped(json, false);
}

export function DocumentoMacelloCreateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): DocumentoMacelloCreateDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'idAnagrafeMittente': !exists(json, 'idAnagrafeMittente') ? undefined : json['idAnagrafeMittente'],
        'idAnagrafeDestinatario': !exists(json, 'idAnagrafeDestinatario') ? undefined : json['idAnagrafeDestinatario'],
        'dataDocumento': !exists(json, 'dataDocumento') ? undefined : (new Date(json['dataDocumento'])),
        'numeroDocumento': !exists(json, 'numeroDocumento') ? undefined : json['numeroDocumento'],
        'dataOperazione': !exists(json, 'dataOperazione') ? undefined : (new Date(json['dataOperazione'])),
        'note': !exists(json, 'note') ? undefined : json['note'],
        'tipo': !exists(json, 'tipo') ? undefined : json['tipo'],
        'idAnagrafePrimario': !exists(json, 'idAnagrafePrimario') ? undefined : json['idAnagrafePrimario'],
        'idAnagrafeSecondario': !exists(json, 'idAnagrafeSecondario') ? undefined : json['idAnagrafeSecondario'],
        'fineCarico': !exists(json, 'fineCarico') ? undefined : json['fineCarico'],
    };
}

export function DocumentoMacelloCreateDTOToJSON(value?: DocumentoMacelloCreateDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'idAnagrafeMittente': value.idAnagrafeMittente,
        'idAnagrafeDestinatario': value.idAnagrafeDestinatario,
        'dataDocumento': value.dataDocumento === undefined ? undefined : (value.dataDocumento.toISOString()),
        'numeroDocumento': value.numeroDocumento,
        'dataOperazione': value.dataOperazione === undefined ? undefined : (value.dataOperazione.toISOString()),
        'note': value.note,
        'tipo': value.tipo,
        'idAnagrafePrimario': value.idAnagrafePrimario,
        'idAnagrafeSecondario': value.idAnagrafeSecondario,
        'fineCarico': value.fineCarico,
    };
}

